export default __webpack_public_path__ + "static/pexels-meruyert-gonullu-6588933-1c722a63ac9f8e5a775b3145d62b9540.jpg";